/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { FindValidInformationRequestsQueryResponse } from "../types/FindValidInformationRequests.ts"

export const findValidInformationRequestsQueryKey = () =>
  [{ url: "/v1/information-request/find-valid-information-requests" }] as const

export type FindValidInformationRequestsQueryKey = ReturnType<
  typeof findValidInformationRequestsQueryKey
>

/**
 * @summary Find valid information requests
 * {@link /v1/information-request/find-valid-information-requests}
 */
export async function findValidInformationRequests(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindValidInformationRequestsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/information-request/find-valid-information-requests`,
    ...requestConfig,
  })
  return res
}

export function findValidInformationRequestsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findValidInformationRequestsQueryKey()
  return queryOptions<
    ResponseConfig<FindValidInformationRequestsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindValidInformationRequestsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findValidInformationRequests({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find valid information requests
 * {@link /v1/information-request/find-valid-information-requests}
 */
export function useFindValidInformationRequests<
  TData = ResponseConfig<FindValidInformationRequestsQueryResponse>,
  TQueryData = ResponseConfig<FindValidInformationRequestsQueryResponse>,
  TQueryKey extends QueryKey = FindValidInformationRequestsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindValidInformationRequestsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findValidInformationRequestsQueryKey()

  const query = useQuery(
    {
      ...findValidInformationRequestsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
